import React from "react";
import { Dropdown } from "react-bootstrap";
import dummyImg from "../../assets/images/profile-education.png";
import { useSelector } from "react-redux";
import { format } from "date-fns";

const EducationCard = ({
  education,
  setShowEditEducationModal,
  handleDeleteEducation,
  setProfileEducationTitleModal,
  setShowProfileEducationModal,
}) => {
  const auth = useSelector((state) => state.auth);

  return (
    <div className="education-card p-16 d-flex mb-24">
      <div className="left-section">
        <div className="education-logo d-flex align-items-center justify-content-center overflow-hidden">
          <img
            src={education?.image || dummyImg}
            alt="Logo"
            className="img-fluid"
          />
        </div>
      </div>
      <div className="right-section w-100">
        <div className="d-flex justify-content-between mb-12">
          <div>
            <h6 className="mb-8 fw-bold ah-text-lg">
              {education?.institution_name || "Not Provided"}
            </h6>
            <span className="ah-text-sm fw-semibold black-700">
              {education?.field_of_study?.name || "Not Provided"}
            </span>
          </div>
          {auth.role === "Instructor" &&
          (window.location.pathname === "/instructor-student" ||
            window.location.pathname === "/student-details") ? (
            ""
          ) : (
            <Dropdown className="custom-dropdown">
              <Dropdown.Toggle variant="light" className="icon-btn py-2 px-4">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 5.71875C9.60406 5.71875 10.0938 5.22906 10.0938 4.625C10.0938 4.02094 9.60406 3.53125 9 3.53125C8.39594 3.53125 7.90625 4.02094 7.90625 4.625C7.90625 5.22906 8.39594 5.71875 9 5.71875Z"
                    fill="#f05203"
                  />
                  <path
                    d="M9 10.0938C9.60406 10.0938 10.0938 9.60406 10.0938 9C10.0938 8.39594 9.60406 7.90625 9 7.90625C8.39594 7.90625 7.90625 8.39594 7.90625 9C7.90625 9.60406 8.39594 10.0938 9 10.0938Z"
                    fill="#f05203"
                  />
                  <path
                    d="M9 14.4688C9.60406 14.4688 10.0938 13.9791 10.0938 13.375C10.0938 12.7709 9.60406 12.2812 9 12.2812C8.39594 12.2812 7.90625 12.7709 7.90625 13.375C7.90625 13.9791 8.39594 14.4688 9 14.4688Z"
                    fill="#f05203"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <Dropdown.Item
                  onClick={() => {
                    setShowEditEducationModal(education);
                    setProfileEducationTitleModal("Edit Education");
                    setShowProfileEducationModal(true);
                  }}
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 1.49999H3.25C2.2835 1.49999 1.5 2.28349 1.5 3.24999V13.75C1.5 14.7165 2.2835 15.5 3.25 15.5H13.75C14.7165 15.5 15.5 14.7165 15.5 13.75V8.49999M14.1124 5.36242L15.0625 4.41238C15.7459 3.72896 15.7459 2.62093 15.0625 1.93752C14.379 1.25409 13.271 1.2541 12.5876 1.93752L11.6376 2.88754M14.1124 5.36242L8.83071 10.6442C8.5864 10.8885 8.27525 11.0551 7.93646 11.1228L5.36245 11.6376L5.87725 9.06359C5.94501 8.72481 6.11153 8.41366 6.35582 8.16937L11.6376 2.88754M14.1124 5.36242L11.6376 2.88754"
                      stroke="#f05203"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Edit
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => handleDeleteEducation(education.id)}
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.75 5.25H12.25C12.25 4.78587 12.0656 4.34075 12.7374 4.01256C11.4092 3.68437 10.9641 3.5 10.5 3.5C10.0359 3.5 9.59075 3.68437 9.26256 4.01256C8.93437 4.34075 8.75 4.78587 8.75 5.25ZM7 5.25C7 4.32174 7.36875 3.4315 8.02513 2.77513C8.6815 2.11875 9.57174 1.75 10.5 1.75C11.4283 1.75 12.3185 2.11875 12.9749 2.77513C13.6313 3.4315 14 4.32174 14 5.25H18.375C18.6071 5.25 18.8296 5.34219 18.9937 5.50628C19.1578 5.67038 19.25 5.89294 19.25 6.125C19.25 6.35706 19.1578 6.57962 18.9937 6.74372C18.8296 6.90781 18.6071 7 18.375 7H17.6033L16.828 16.0475C16.7535 16.9212 16.3537 17.735 15.7079 18.3281C15.062 18.9211 14.2171 19.2501 13.3403 19.25H7.65975C6.78292 19.2501 5.93799 18.9211 5.29213 18.3281C4.64627 17.735 4.24653 16.9212 4.172 16.0475L3.39675 7H2.625C2.39294 7 2.17038 6.90781 2.00628 6.74372C2.17038 5.34219 2.39294 5.25 2.625 5.25H7ZM13.125 10.5C13.125 10.2679 13.0328 10.0454 12.8687 9.88128C12.7046 9.71719 12.4821 9.625 12.25 9.625C12.0179 9.625 11.7954 9.71719 11.6313 9.88128C11.4672 10.0454 11.375 10.2679 11.375 10.5V14C11.375 14.2321 11.4672 14.4546 11.6313 14.6187C11.7954 14.7828 12.0179 14.875 12.25 14.875C12.4821 14.875 12.7046 14.7828 12.8687 14.6187C13.0328 14.4546 13.125 14.2321 13.125 14V10.5ZM8.75 9.625C8.51794 9.625 8.29538 9.71719 8.13128 9.88128C7.96719 10.0454 7.875 10.2679 7.875 10.5V14C7.875 14.2321 7.96719 14.4546 8.13128 14.6187C8.29538 14.7828 8.51794 14.875 8.75 14.875C8.98206 14.875 9.20462 14.7828 9.36872 14.6187C9.53281 14.4546 9.625 14.2321 9.625 14V10.5C9.625 10.2679 9.53281 10.0454 9.36872 9.88128C9.20462 9.71719 8.98206 9.625 8.75 9.625Z"
                      fill="#f05203"
                    />
                  </svg>
                  Delete education
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>

        <p className="ah-text-base black-700 fw-normal mb-16">
          {education?.about_yourself || "No description provided"}
        </p>

        <div className="d-flex flex-wrap align-items-center">
          <div className="me-20 d-flex align-items-center">
            <svg
              width="14"
              height="17"
              viewBox="0 0 14 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.96429 0C8.81133 0 10.5827 0.733735 11.8888 2.03979C13.1948 3.34585 13.9286 5.11724 13.9286 6.96429C13.9286 9.90714 11.8607 13.1143 7.77857 16.62C7.55159 16.815 7.26219 16.9221 6.96295 16.9218C6.66371 16.9216 6.3745 16.814 6.14786 16.6186L5.87786 16.3843C1.97643 12.97 0 9.84143 0 6.96429C0 5.11724 0.733735 3.34585 2.03979 2.03979C3.34585 0.733735 5.11724 0 6.96429 0ZM6.96429 4.28571C6.25388 4.28571 5.57258 4.56792 5.07025 5.07025C4.56792 5.57258 4.28571 6.25388 4.28571 6.96429C4.28571 7.67469 4.56792 8.35599 5.07025 8.85832C5.57258 9.36065 6.25388 9.64286 6.96429 9.64286C7.67469 9.64286 8.35599 9.36065 8.85832 8.85832C9.36065 8.35599 9.64286 7.67469 9.64286 6.96429C9.64286 6.25388 9.36065 5.57258 8.85832 5.07025C8.35599 4.56792 7.67469 4.28571 6.96429 4.28571Z"
                fill="#F05203"
              />
            </svg>

            <span className="ah-text-base fw-semibold ms-10">
              {education?.location || "Not Provided"}
            </span>
          </div>
          <div className="me-20 d-flex align-items-center">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.75 17.5C11.0706 17.5 13.2962 16.5781 14.9372 14.9372C16.5781 13.2962 17.5 11.0706 17.5 8.75C17.5 6.42936 16.5781 4.20376 14.9372 2.56282C13.2962 0.921872 11.0706 0 8.75 0C6.42936 0 4.20376 0.921872 2.56282 2.56282C0.921872 4.20376 0 6.42936 0 8.75C0 11.0706 0.921872 13.2962 2.56282 14.9372C4.20376 16.5781 6.42936 17.5 8.75 17.5ZM9.6875 4.375C9.6875 4.12636 9.58873 3.8879 9.41291 3.71209C9.2371 3.53627 8.99864 3.4375 8.75 3.4375C8.50136 3.4375 8.2629 3.53627 8.08709 3.71209C7.91127 3.8879 7.8125 4.12636 7.8125 4.375V8.75C7.8125 8.89554 7.84639 9.03909 7.91147 9.16926C7.97656 9.29944 8.07107 9.41267 8.1875 9.5L10.6875 11.375C10.786 11.4489 10.8981 11.5026 11.0173 11.5332C11.1366 11.5637 11.2607 11.5705 11.3826 11.5531C11.5045 11.5357 11.6217 11.4944 11.7276 11.4317C11.8336 11.369 11.9261 11.286 12 11.1875C12.0739 11.089 12.1276 10.9769 12.1582 10.8577C12.1887 10.7384 12.1955 10.6143 12.1781 10.4924C12.1607 10.3705 12.1194 10.2533 12.0567 10.1474C11.994 10.0414 11.911 9.94887 11.8125 9.875L9.6875 8.28125V4.375Z"
                fill="#F05203"
              />
            </svg>

            <span className="ah-text-base fw-semibold ms-10">
              {education?.start_date
                ? format(new Date(education.start_date), "MMM, yyyy")
                : "Not Provided"}{" "}
              -{" "}
              {education?.end_date
                ? format(new Date(education.end_date), "MMM, yyyy")
                : "Present"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducationCard;
